module.exports = __webpack_public_path__ + "img/questions-x.b49b0aac.svg";